function errorHandling(error) {
  var listError = [];
  if(error.status > 200 && error.status <= 300) {
    /* request success but the http status code is not 200 */
    listError.push('HTTP status code : '+error.status+ ' (invalid)')
  } else if(error.response) {
    /* The request was made and the server responded with a status code
    that falls out of the range of 2xx */
    // Jika response dari server 400 dan memiliki reason : WRONG-PROCESS maka akan masuk kesini
    listError.push(error.response.data.reason);
  } else {
    /* Something happened in setting up the request that triggered an Error */
    listError.push(error.message);
  }
  if(listError.length == 0){
    listError.push('System Error');
  }
  return listError;
}

export default {
  errorHandling
}